import { LazyImage } from "@website/ui/lazy-image";
import { numberConvert } from "@website/utils/number-convert";
import snappProBadge from "@website/widget/header/assets/pro_badge.svg";
import { FC, memo } from "react";
import { SnappProDiscountChipProperties } from "./snapp-pro-discount-chip.types";

const Component: FC<SnappProDiscountChipProperties> = ({ percentage }) => (
  <div className="bg-light-mode-pro-light flex h-[17px] flex-row items-center gap-1 rounded-3xl p-[2px]">
    <LazyImage
      src={snappProBadge.src}
      alt="Snapp Pro"
      loading="eager"
      fetchPriority="high"
      width={24}
      height={13}
    />
    <span className="text-light-mode-pro text-[10px] font-medium">
      {typeof percentage === "number"
        ? `%${numberConvert(percentage, { locale: "fa" })}`
        : percentage}
    </span>
  </div>
);

export const SnappProDiscountChip = memo(Component);
